import { createSelector } from 'reselect';
import { ACTIVITY_FILTERS, NOTIFICATION_TYPES } from './constants';

const DEFAULT_ARRAY = [];
const slice = (state) => state.notificationReducer;

export const selectUnreadGroups = createSelector(
  slice,
  (s) => s.unreadGroups ?? DEFAULT_ARRAY,
);

export const selectReadGroups = createSelector(
  slice,
  (s) => s.readGroups ?? DEFAULT_ARRAY,
);

export const selectUnreadTaskCount = createSelector(
  slice,
  (s) => s.unreadTaskCount ?? 0,
);

export const selectHasMore = createSelector(slice, (s) => s.hasMore);
export const selectHasMoreUnread = createSelector(slice, (s) => s.hasMoreUnread);
export const selectIsLoading = createSelector(slice, (s) => s.loading);
export const selectIsLoadingMore = createSelector(slice, (s) => s.loadingMore);
export const selectActiveFilter = createSelector(slice, (s) => s.activeFilter);
export const selectPendingCount = createSelector(slice, (s) => s.pendingCount);
export const selectPendingGroups = createSelector(slice, (s) => s.pendingGroups ?? DEFAULT_ARRAY);

export const selectHasAnyGroups = createSelector(
  selectUnreadGroups,
  selectReadGroups,
  (unread, read) => unread.length > 0 || read.length > 0,
);

function applyFilter(groups, activeFilter) {
  if (activeFilter === ACTIVITY_FILTERS[0]) return groups;
  return groups
    .map((g) => ({
      ...g,
      events: g.events.filter((e) => {
        if (activeFilter === ACTIVITY_FILTERS[1]) {
          return (
            e.notificationType === NOTIFICATION_TYPES.TASK_NOTIFICATION ||
            e.notificationType === NOTIFICATION_TYPES.COMMENT_NOTIFICATION
          );
        }
        if (activeFilter === ACTIVITY_FILTERS[2]) return !!e.assignee?.isMentioned;
        if (activeFilter === ACTIVITY_FILTERS[3]) {
          return e.notificationType === NOTIFICATION_TYPES.CHAT_REPLY_NOTIFICATION;
        }
        if (activeFilter === ACTIVITY_FILTERS[4]) {
          return e.action === 'taskAssignment';
        }
        return true;
      }),
    }))
    .filter((g) => g.events.length > 0);
}

export const selectFilteredUnreadGroups = createSelector(
  selectUnreadGroups,
  selectActiveFilter,
  (groups, filter) => applyFilter(groups, filter),
);

export const selectFilteredReadGroups = createSelector(
  selectReadGroups,
  selectActiveFilter,
  (groups, filter) => applyFilter(groups, filter),
);

export const selectHasAnyFilteredGroups = createSelector(
  selectFilteredUnreadGroups,
  selectFilteredReadGroups,
  (unread, read) => unread.length > 0 || read.length > 0,
);
